import dynamic from 'next/dynamic'

export const DynamicDeepLinkChangeStoreModal = dynamic(
  () => import('.').then((mod) => mod.DeepLinkChangeStoreModal),
  { ssr: false },
)
